import React from 'react';

function PageNotFound() {
  return (
    <div>
      <h1>Sorry !! Page not found</h1>
    </div>
  )
}

export default PageNotFound;
